import React from 'react'
import { Divider, makeStyles, mergeClasses, tokens } from '@fluentui/react-components'
import { Title } from '../text/Title'

const useStyles = makeStyles({
   card: {
      borderRadius: tokens.borderRadiusLarge,
      display: 'flex',
      flexDirection: 'column',
      gap: tokens.spacingHorizontalM,
      boxSizing: 'border-box',
      maxHeight: '100%',
      boxShadow: tokens.shadow8,
      padding: `${tokens.spacingVerticalXXL} ${tokens.spacingHorizontalXXXL}`,
      backgroundColor: tokens.colorPaletteMarigoldBackground1,
   },
   transparentInPhone: {
      '@media screen and (max-width: 1007px)': {
         boxShadow: 'none',
         padding: 0,
         backgroundColor: 'transparent',
      },
   },
   showOnlyLarge: {
      '@media screen and (max-width: 1007px)': {
         display: 'none',
      },
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
   },
   content: {
      overflow: 'hidden',
   },
   noMaxHeight: {
      maxHeight: 'auto',
   },
})
type CardProps = {
   title: string
   titleAs?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5'
   children: JSX.Element | JSX.Element[] | string | string[]
   className?: string
   contentClassName?: string
   headerClassName?: string
   transparentInPhone?: boolean
   action?: JSX.Element
   hideDivider?: boolean
   noMaxHeight?: boolean
}
export const Card = ({
   title,
   titleAs,
   children,
   className,
   transparentInPhone,
   contentClassName,
   action,
   headerClassName,
   hideDivider = false,
   noMaxHeight,
}: CardProps) => {
   const classes = useStyles()
   return (
      <article
         aria-label="group"
         className={mergeClasses(transparentInPhone ? classes.transparentInPhone : '', classes.card, noMaxHeight ? classes.noMaxHeight : '', className ?? '')}
      >
         <header className={mergeClasses(classes.showOnlyLarge, classes.header, headerClassName)}>
            <Title as={titleAs ?? 'h2'}>{title}</Title>
            {action ? action : null}
         </header>
         {!hideDivider && <Divider className={classes.showOnlyLarge} appearance="brand" />}
         <main className={mergeClasses(classes.content, contentClassName ?? '')}>{children}</main>
      </article>
   )
}
